import React from "react";
import {Variant} from "react-bootstrap/types";

export type ThumbsUpIconVariant = Variant;

const variants = {
    primary: "#973694",
    info: "#cccccc"
};

export function ThumbsDownIcon({variant}: { variant: ThumbsUpIconVariant }) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_12_1936)">
                <path
                    d="M0 1.75V9.25C0 9.66422 0.335781 10 0.75 10H3.25C3.66422 10 4 9.66422 4 9.25V1.75C4 1.33578 3.66422 1 3.25 1H0.75C0.335781 1 0 1.33578 0 1.75ZM1.25 8C1.25 7.58578 1.58578 7.25 2 7.25C2.41422 7.25 2.75 7.58578 2.75 8C2.75 8.41422 2.41422 8.75 2 8.75C1.58578 8.75 1.25 8.41422 1.25 8ZM9.75 16C9.11928 16 8.82859 14.7721 8.68966 14.1939C8.52697 13.5168 8.35875 12.8167 7.89612 12.3532C6.88147 11.3368 6.34916 10.0417 5.11122 8.8185C5.07599 8.78368 5.04802 8.74221 5.02894 8.6965C5.00985 8.65079 5.00003 8.60175 5.00003 8.55222V1.87191C5.00003 1.6675 5.16388 1.50072 5.36825 1.49697C5.86297 1.48791 6.51494 1.21325 7.01359 0.991406C8.00591 0.549937 9.24091 0.00053125 10.7498 0H10.8387C12.1755 0 13.7563 0.0129063 14.3942 0.929281C14.6564 1.30606 14.7206 1.77409 14.5863 2.32403C15.096 2.85694 15.3695 3.851 15.0982 4.66019C15.6465 5.39244 15.6964 6.41431 15.3891 7.14359L15.3925 7.14703C15.7642 7.52044 16.0026 8.12388 16 8.68444C15.9951 9.63294 15.1826 10.5 14.139 10.5H10.9601C11.1884 11.3856 12 12.1291 12 13.4546C12 15.75 10.5 16 9.75 16Z"
                    fill={variants[variant] || variants["primary"]}/>
            </g>
            <defs>
                <clipPath id="clip0_12_1936">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>

    );
}